import { MantineThemeOverride, Switch } from '@mantine/core';

const theme: MantineThemeOverride = {
  fontFamily: 'Barlow',

  headings: {
    sizes: {
      h1: {
        fontSize: '1.8rem',
      },
    },
  },

  primaryColor: 'brand',

  black: '#2f2f2f',

  colors: {
    brand: [
      '#DAE1E1',
      '#C2D0D1',
      '#AAC2C4',
      '#93B7BA',
      '#7BAFB4',
      '#61ABB2',
      '#47AAB3',
      '#4A9197',
      '#497D81',
      '#476C6F',
    ],
  },

  cursorType: 'pointer',

  components: {
    Switch: Switch.extend({
      defaultProps: {
        withThumbIndicator: false,
      },
    }),
  },
};

export default theme;
